import React            from 'react';
import { useSelector }  from 'react-redux';

import { EFECTIVA }     from '../../../data/audienceStates';

import moment           from 'moment';



const SchedulingInfo = () => {
    
    
    // Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    
    
    // Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">DATOS AGENDAMIENTO</h6>
                </div>
                <div className="card-body">
                    <div className="h6 mb-0 font-weight-bold text-gray-800">
                        <div className="row">
                            <div className="col-md-3">
                                <small>Inicio Prog.:</small>
                                <br/>
                                { audience.inicio ? moment(audience.inicio).format('DD/MM/YYYY HH:mm') : '' }
                            </div>
                            <div className="col-md-3">
                                <small>Fin Prog.:</small>
                                <br/>
                                { audience.fin ? moment(audience.fin).format('DD/MM/YYYY HH:mm') : '' }
                            </div>
                            <div className="col-md-6">
                                <small>Operador:</small>
                                <br/>
                                { audience.operador ? `${audience.operador.apellido}, ${audience.operador.nombre}` : '' }
                            </div>
                            <div className="col-md-6">
                                <small>Sala:</small>
                                <br/>
                                { audience.sala ? audience.sala.descripcion : '' }
                            </div>
                            {   audience.estado.id >= EFECTIVA 
                                    ? 
                                        <React.Fragment>
                                            <div className="col-md-3">
                                                <small>Inicio Real:</small>
                                                <br/>
                                                { audience.inicioReal ? moment(audience.inicioReal).format('DD/MM/YYYY HH:mm') : '' }
                                            </div>
                                            <div className="col-md-3">
                                                <small>Fin Real:</small>
                                                <br/>
                                                { audience.finReal ? moment(audience.finReal).format('DD/MM/YYYY HH:mm') : '' }
                                            </div>
                                        </React.Fragment>
                                    : 
                                        null
                            }
                            {   audience.estado.descripcion==="Agendada" && audience.enviarEnlace===1
                                    ?
                                        <div className="col-md-12">
                                            <small>Enlace de Audiencia Remota:</small>
                                            <br/>
                                            {   audience.sessionUrl
                                                    ?
                                                        <a href={audience.sessionUrl} target="_blank">
                                                            { audience.sessionUrl }
                                                        </a>
                                                    :
                                                        null
                                            }
                                        </div>    
                                    :
                                        null
                            }
                            {   audience.observacionAgendamiento 
                                    ? 
                                        <div className="col-md-12">
                                            <small>Observaciones:</small>
                                            <br/>
                                            { audience.observacionAgendamiento }
                                        </div>
                                    : 
                                        null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SchedulingInfo;